var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
var WidthElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var GetElementWidthEnabled = function (_a) {
    var onWidthChange = _a.onWidthChange, children = _a.children;
    var elementRef = useRef(null);
    var onWidthChangeRef = useRef(onWidthChange);
    onWidthChangeRef.current = onWidthChange;
    useEffect(function () {
        function onResize() {
            if (elementRef.current) {
                onWidthChangeRef.current(elementRef.current.getBoundingClientRect().width);
            }
        }
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    var setElementRef = useCallback(function (element) {
        elementRef.current = element;
        onWidthChangeRef.current(element ? element.getBoundingClientRect().width : null);
    }, []);
    return React.createElement(WidthElement, { ref: setElementRef }, children);
};
function GetElementWidth(props) {
    return props.disabled ? (React.createElement(WidthElement, null, props.children)) : (React.createElement(GetElementWidthEnabled, __assign({}, props)));
}
export default GetElementWidth;
var templateObject_1;
